var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectBuildingsPark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 1207,
    viewBox: "0 0 2000 1207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "A35",
    d: "M1490.18 261.51V291.321H497.729V253.208L466.031 218.868V210.944H497.729V180.774H875.843V163.274H885.654V178.491H1094.71V163.274H1103.01V180.774H1460.37V172.83L1466.79 166.415H1483.39V212.453H1531.69V223.396L1490.18 261.51Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 2.26415
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "A34",
    d: "M1610.56 480.755H369.805L373.578 291.698H1607.16L1610.56 480.755Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 2.26415
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "A31",
    d: "M1613.96 961.132H624.531V941.132H612.078V741.132H1613.96V961.132Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 2.26415
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "A32",
    d: "M314.719 741.132H1689.06V726.792H1674.34V688.302H1634.34V590.566H856.606V614.717H515.473V596.226L498.87 592.075H488.304V614.717H366.417V689.811H323.021V728.302H314.719V741.132Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 2.26415
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "A33",
    d: "M856.596 590.566H1611.69L1610.56 480.755H369.802L366.406 614.717H488.294V592.075H498.86L515.464 596.226V614.717H856.596V590.566Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 2.26415
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectBuildingsPark);
export default __webpack_public_path__ + "static/media/select_buildings_park.07bfcc98.svg";
export { ForwardRef as ReactComponent };